import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_GCP_PROJECT,
  storageBucket: `${import.meta.env.VITE_GCP_PROJECT}.appspot.com`,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
}

const firebaseApp = initializeApp(firebaseConfig)
const firebaseAuth = getAuth(firebaseApp)

export {
  firebaseAuth,
}

export {
  connectAuthEmulator,
  getRedirectResult,
  SAMLAuthProvider,
  signInWithRedirect,
  signOut,
} from 'firebase/auth'

export type {
  User,
  UserCredential,
} from 'firebase/auth'
